import { K8sProviderIcons } from '@cast/features-cluster-ui';
import {
  isClusterManaged,
  isKentManagedCluster,
} from '@cast/shared-cluster-context-data-access';
import { Cluster } from '@cast/types';

type ManagedByCellProps = {
  cluster: Cluster;
};

export const ManagedByCell = ({ cluster }: ManagedByCellProps) => (
  <K8sProviderIcons
    provider={cluster.providerType}
    castEnabled={isClusterManaged(cluster)}
    isKentManagedCluster={isKentManagedCluster(cluster)}
    size={20}
  />
);
